import '../pages.css';
import { Link } from 'react-router-dom';

const Zirconia = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/fixed" className="back-link">← Back to Fixed Prosthetics</Link>
                    <h1>Full-Contour Zirconia</h1>
                    <p className="product-tagline">Exceptional strength meets digital precision</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            <strong>AbELab</strong> full-contour zirconia restorations are digitally designed and milled to achieve exceptional
                            smoothness and precision. These metal-free restorations offer the highest flexural strength among all-ceramic options
                            while remaining gentle on opposing dentition. They are fully biocompatible and ideal for high-load areas.
                        </p>
                    </div>

                    <div className="product-two-column">
                        <div className="product-section">
                            <h2>Indications</h2>
                            <ul>
                                <li>Single crowns</li>
                                <li>Bridges of various configurations</li>
                                <li>Inlay bridges</li>
                                <li>Screw-retained implant restorations</li>
                            </ul>
                            <p>Also suitable as an esthetic alternative to PFMs in limited space cases.</p>
                        </div>

                        <div className="product-section">
                            <h2>Contraindications</h2>
                            <ul>
                                <li>High esthetic-demand cases requiring precise shade matching</li>
                                <li>Situations requiring strong adhesive bonding</li>
                            </ul>
                        </div>
                    </div>

                    <div className="product-section">
                        <h2>Preparation</h2>
                        <ul>
                            <li>Chamfer or feather-edge margin recommended</li>
                            <li>Ideal reduction: 1 mm buccal, lingual, occlusal</li>
                            <li>Minimum reduction: 0.5 mm</li>
                            <li>Minimum occlusal reduction: 0.5 mm (1 mm preferred)</li>
                        </ul>
                    </div>

                    <div className="product-section">
                        <h2>Cementation</h2>
                        <ul>
                            <li>Zirconia primers (Z-Prime™, Clearfil™ Ceramic Primer)</li>
                            <li>Resin-reinforced glass ionomer (RelyX™ Luting)</li>
                            <li>Resin cement when retention is limited</li>
                        </ul>
                        <p>Internal surfaces must be cleaned with <strong>Ivoclean</strong> prior to cementation.</p>
                    </div>

                    <div className="product-section">
                        <h2>Technical Notes</h2>
                        <ul>
                            <li>Advantage Z: 700–750 MPa (ideal for posterior use)</li>
                            <li>Simple Z: 750–800 MPa (suitable for anterior and posterior)</li>
                        </ul>

                        <p><em>Natural tooth flexural strength:</em></p>
                        <ul>
                            <li>Molar: ~305 MPa</li>
                            <li>Premolar: ~248 MPa</li>
                        </ul>
                    </div>

                    <div className="product-section product-codes">
                        <h2>Codes</h2>
                        <ul>
                            <li><strong>D2740</strong> – Crown, porcelain/ceramic substrate</li>
                            <li><strong>D6245</strong> – Pontic, porcelain/ceramic</li>
                            <li><strong>D6740</strong> – Abutment crown, porcelain/ceramic</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Zirconia;
